import React from "react";
import { exportToExcel } from "../common";
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  Edit,
  EditButton,
  BooleanInput,
  NumberInput,
} from "react-admin";

/* ===========================
   EXPORT
=========================== */
const exporter = (products) => {
  const arrangedProducts = products.map((product) => ({
    Name: product.name,
    "Active Status": product.isActive,
    Installments: product.installmentArr,
  }));
  exportToExcel(arrangedProducts, "products");
};

/* ===========================
   TRANSFORM (FIX INSTALLMENTS + AMOUNTS)
=========================== */
const transformProduct = (data) => {
  const newData = { ...data };

  /* ---------------------------
     INSTALLMENTS (STRING ONLY)
  --------------------------- */
  if (newData.installmentArr) {
    const arr = newData.installmentArr
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    newData.installmentArr = arr.join(", ");
  }

  // ❌ NEVER send installmentArray
  delete newData.installmentArray;

  /* ---------------------------
     AMOUNTS (NO NULLS)
  --------------------------- */
  const buildAmount = (v) =>
    v !== undefined && v !== null && v !== ""
      ? [Number(v)]
      : undefined;

  newData.amounts = {
    INR: buildAmount(newData.amountInr),
    USD: buildAmount(newData.amountUsd),
    EUR: buildAmount(newData.amountEur),
    GBP: buildAmount(newData.amountGbp),
    AUD: buildAmount(newData.amountAud),
    CNY: buildAmount(newData.amountCny),
  };

  // Optional: remove empty currency keys
  Object.keys(newData.amounts).forEach((k) => {
    if (!newData.amounts[k]) delete newData.amounts[k];
  });

  return newData;
};

/* ===========================
   SHARED FORM
=========================== */
const ProductForm = ({ isCreate = false }) => (
  <>
    <TextInput label="Product Name" source="name" fullWidth />

    {!isCreate && (
      <TextInput label="Product ID" disabled source="productId" />
    )}

    <div style={{ display: "flex", gap: 16 }}>
      <NumberInput label="Amount (INR)" source="amountInr" />
      <NumberInput label="Amount (USD)" source="amountUsd" />
      <NumberInput label="Amount (EUR)" source="amountEur" />
      <NumberInput label="Amount (GBP)" source="amountGbp" />
      <NumberInput label="Amount (AUD)" source="amountAud" />
      <NumberInput label="Amount (CNY)" source="amountCny" />
    </div>

    <TextInput label="Line 1" source="line1" />
    <TextInput label="Line 2" source="line2" />
    <TextInput multiline label="Line 3" source="line3" />

    <TextInput multiline label="Box 1" source="box1" />
    <TextInput multiline label="Box 2" source="box2" />

    <NumberInput label="Max Quantity" source="maxQty" />

    {/* INSTALLMENTS */}
    <TextInput
      label="Installments (comma separated)"
      source="installmentArr"
      fullWidth
    />

    {/* IMAGES */}
    <ImageInput
      multiple
      source="imgs"
      label="Product Images"
      accept="image/*"
      format={(imgs) => {
        if (!imgs) return [];
        if (imgs.length > 0 && typeof imgs[0] === "string") {
          return imgs.map((url) => ({ src: url }));
        }
        return imgs;
      }}
    >
      <ImageField source="src" />
    </ImageInput>

    <BooleanInput
      label="Active Status"
      source="isActive"
      defaultValue={isCreate ? true : undefined}
    />

    <BooleanInput
      label="Only Campaign"
      source="onlyCampaign"
      defaultValue={isCreate ? false : undefined}
    />
  </>
);

/* ===========================
   EDIT PRODUCT
=========================== */
export const productEdit = (props) => (
  <Edit
    title="Edit product details"
    transform={transformProduct}
    {...props}
  >
    <SimpleForm>
      <ProductForm />
    </SimpleForm>
  </Edit>
);

/* ===========================
   CREATE PRODUCT
=========================== */
export const ProductCreate = (props) => (
  <Create transform={transformProduct} {...props}>
    <SimpleForm>
      <ProductForm isCreate />
    </SimpleForm>
  </Create>
);

/* ===========================
   PRODUCT LIST
=========================== */
export default (props) => (
  <List exporter={exporter} bulkActionButtons={false} {...props}>
    <Datagrid>
      <TextField source="name" />
      <TextField source="isActive" />
      <TextField label="Installments" source="installmentArr" />
      <EditButton />
    </Datagrid>
  </List>
);
